module.exports = __webpack_public_path__ + "img/a3f2880.svg";